const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'contractorContacts',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            title: true,
            firstname: true,
            lastname: true,
            capacity: true,
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_contractorContacts': true,
        },
    },

    methods: {
        /**
         * this function is used to handle the different kinds of errors.
         * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
         * NOTE: if this function resolves the given context is always the original context and NOT the error handling context.
         *
         * @param   context             {} - action perform context
         *          {
         *              component: ...
         *              [action]: ...
         *              error: {
         *                  statusCode: <statusCode>            mixed - status code || 'clientError'
         *                  name: <statusCode>                  string - error name
         *                  errorCode: <statusCode>             string - error code
         *                  message: <statusCode>               string - error message
         *                  details: <statusCode>               string - error details
         *                  [childErrors]: []                   [] - list of child errors
         *              },
         *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
         *                                      int - this error handling type defines the state of error handling
         *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
         *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
         *          }
         * @returns Promise
         */
        handleError: function(context){
            const baseError = utils.extractBaseError(context.error);

            if(
                baseError.statusCode == 409 &&
                baseError.errorCode == 'SEQUELIZE_UNIQUE_CONSTRAINT_ERROR' &&
                baseError.table == 'um_users' &&
                baseError.column == 'code'
            ){
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:addUser.codeAlreadyInUse'
                        }
                    }, {
                        rollbackContext: context,
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                )
            }

            context.errorUnhandled = true;
            return utils.promise.resolve(context);
        },
    },
}